import _ from 'lodash';

import actionTypes from '../constants/action-types';
import DashboardApi from '../../../../api/dashboard-api';
import dashboardConstants from '../constants/dashboard-constants';

export const getChartData = () => {
  return async dispatch => {
    dispatch(handleFetchingChartData(true));
    try {
      const response = await DashboardApi.getChartData();
      const data = response && response.data;
      dispatch(handleGetChartData(data));
      dispatch(handleFetchingChartData(false));
    } catch (error) {
      dispatch(handleFetchingChartData(false));
    }
  };
};

export const getSummary = () => {
  return async dispatch => {
    dispatch(handleFetchingSummaryData(true));
    try {
      const response = await DashboardApi.getSummary();
      const summaryArray = response && response.data ? response.data : [];
      const summary = _.find(summaryArray, { user_type: dashboardConstants.filter_user_types.trader.value }) || {};
      const partnersSummary = _.find(summaryArray, { user_type: dashboardConstants.filter_user_types.partner.value }) || {};
      dispatch(handleGetSummary(summary, partnersSummary));
      dispatch(handleFetchingSummaryData(false));
    } catch (error) {
      dispatch(handleFetchingSummaryData(false));
    }
  };
};

export const handleGetChartData = data => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_CHART_DATA,
    data,
  };
};

export const handleFetchingChartData = isFetching => {
  return {
    type: actionTypes.HANDLE_FETCHING_CHART_DATA,
    data: isFetching,
  };
};

export const handleGetSummary = (summary, partnersSummary) => {
  return {
    type: actionTypes.HANDLE_SUCCESS_GET_SUMMARY_DATA,
    data: {
      summary,
      partnersSummary,
    },
  };
};

export const handleFetchingSummaryData = isFetching => {
  return {
    type: actionTypes.HANDLE_FETCHING_SUMMARY_DATA,
    data: isFetching,
  };
};

export const handleQuickLinkChange = link => {
  return {
    type: actionTypes.HANDLE_QUICK_LINK_CHANGE,
    data: link,
  };
};

export const toggleBannerPreviewModal = (show, bannerHtml) => {
  return {
    type: actionTypes.TOGGLE_BANNER_PREVIEW_MODAL,
    data: {
      show,
      bannerHtml,
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/main/dashboard/actions/dashboard-actions.js